module.exports = __webpack_public_path__ + "img/user.150d7b13.svg";